import { RouterThunk } from '@gasbuddy/react';

import { Unknown } from './unknown';
import Offer from '../offer';

const routes = {
  routes: [{ component: Offer, path: '/offer/:offerName', exact: true }],
  final: {
    routes: [
      { component: Unknown, path: '//' },
    ],
  },
};

export const Router = RouterThunk(routes);
